import React, { useState } from "react";

const ImageGallery = ({ images = [], title }) => {
  const [activeImage, setActiveImage] = useState(images[0] || "");

  if (!images.length) {
    return null;
  }

  return (
    <section className="things-section-card">
      {
        activeImage.type === "video" ? (
          <video src={activeImage.url} controls className="things-hero-image mb-3" />
        ) : (
          <img src={activeImage.url} alt={title} className="things-hero-image mb-3" />
        )
      }
     
      <div className="things-thumb-grid">
        {images.map((image) => (
          <button
            key={image.url}
            type="button"
            className={`things-thumb-btn ${activeImage.url === image.url ? "active" : ""}`}
            onClick={() => setActiveImage(image)}
          >
            {
              image.type === "video" ? (
                <video src={image.url}/>
              ) : (
                <img src={image.url} alt={`${title} thumbnail`} />
              )
            }
          </button>
        ))}
      </div>
    </section>
  );
};

export default ImageGallery;
